import { render, staticRenderFns } from "./SinosMonitoramento.vue?vue&type=template&id=2db14d23&scoped=true&"
import script from "./SinosMonitoramento.vue?vue&type=script&lang=js&"
export * from "./SinosMonitoramento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db14d23",
  null
  
)

export default component.exports